import React, { FunctionComponent } from 'react';

const VoidElement: FunctionComponent = ({ children, ...atrributes }: any) => {
  /*
   * This component is used to wrap list items with a unique key
   * Usage:
   * <VoidElement key={'provide_a_key_' + id}>...</VoidElement>
   */
  return (
    <>{children}</>
  )
}

export default VoidElement;
